import React, { useContext } from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import { FiMail, FiFileText } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import AppContext from 'context/Context';

const CardsEmpleados = ({ empleados = [] }) => {
    const navigate = useNavigate();
    const { config: { isDark } } = useContext(AppContext);

    return (
        <>
            {empleados.map((emp) => (
                <Col key={emp.idUsuario} xs={12}>
                    <Card
                        className="shadow-none border hover-shadow-sm transition-base"
                        style={{ cursor: 'pointer', transition: 'background-color 0.2s ease' }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = isDark ? '#1e293b' : '#f8f9fa'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                        <div
                            onClick={(e) => {
                                const url = `/administracion/usuarios-sistema/detalle/${emp.idUsuario}`;
                                if (e.ctrlKey || e.metaKey) {
                                    window.open(url, '_blank');
                                } else {
                                    navigate(url);
                                }
                            }}
                            onAuxClick={(e) => {
                                if (e.button === 1) {
                                    window.open(`/administracion/usuarios-sistema/detalle/${emp.idUsuario}`, '_blank');
                                }
                            }}
                            style={{ textDecoration: 'none' }}
                        >
                            <Card.Body className="p-3">
                                <Row className="align-items-center g-3">
                                    {/* FOTO DE PERFIL */}
                                    <Col xs={12} sm={6} md={2} className="text-center">
                                        <div className="position-relative d-inline-block">
                                            <div style={{
                                                width: '110px',
                                                height: '110px',
                                                borderRadius: '50%',
                                                backgroundColor: '#f8f9fa',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                overflow: 'hidden',
                                                border: '3px solid #e9ecef'
                                            }}>
                                                {emp.vFoto && emp.vFoto !== '/img/team/nofoto50.png' ? (
                                                    <img
                                                        src={emp.vFoto.startsWith('data:') ? emp.vFoto : `data:image/jpeg;base64,${emp.vFoto}`}
                                                        alt="Profile"
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                        onError={(e) => {
                                                            e.target.style.display = 'none';
                                                            e.target.nextSibling.style.display = 'flex';
                                                        }}
                                                    />
                                                ) : null}

                                                {(!emp.vFoto || emp.vFoto === '/img/team/nofoto50.png') && (
                                                    <div style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: '#e3f2fd',
                                                        fontSize: '32px',
                                                        fontWeight: 'bold',
                                                        color: '#1976d2'
                                                    }}>
                                                        {`${emp.vNombre?.charAt(0) || ''}${emp.vApellidos?.charAt(0) || ''}`}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Col>

                                    {/* INFORMACIÓN PRINCIPAL */}
                                    <Col xs={12} sm={6} md={3} className="border-end-md">
                                        <h6 className="mb-1 text-900 text-uppercase">{emp.vNombre} {emp.vApellidos}</h6>
                                        <div className="d-flex align-items-center mb-2">
                                            <span className="text-primary fw-bold">#{emp.idUsuario}</span>
                                        </div>
                                        <Badge bg={emp.bIsActive == 1 ? 'success' : 'danger'}>
                                            {emp.bIsActive == 1 ? "ACTIVO" : "INACTIVO"}
                                        </Badge>
                                    </Col>

                                    {/* CATEGORÍA */}
                                    <Col xs={12} sm={6} md={2} className="border-end-md">
                                        <div className="text-600 fs--2 mb-1 fw-semi-bold">Categoría</div>
                                        {emp.iCategoria === 1 && <Badge bg="soft-primary" className="text-primary fs--1">Empleado</Badge>}
                                        {emp.iCategoria === 2 && <Badge bg="soft-danger" className="text-danger fs--1">Hon. Prof.</Badge>}
                                        {emp.iCategoria === 3 && <Badge bg="soft-warning" className="text-warning fs--1">Residente</Badge>}
                                        {emp.iCategoria >= 4 && <Badge bg="soft-success" className="text-success fs--1">Becario</Badge>}
                                    </Col>

                                    {/* DATOS DE CONTACTO */}
                                    <Col xs={12} sm={6} md={3}>
                                        <div className="fs--1">
                                            <div className="d-flex align-items-center mb-2">
                                                <FiFileText className="text-primary me-2" size={14} />
                                                <span className="text-800 text-uppercase">{emp.vCURP || 'N/A'}</span>
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <FiMail className="text-primary me-2" size={14} />
                                                <span className="text-800">{emp.vEmailTrabajo || 'Sin correo'}</span>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={6} md={2} className="text-center d-flex flex-column justify-content-center gap-2">
                                        <Link
                                            to={`/administracion/usuarios-sistema/detalle/${emp.idUsuario}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-sm btn-primary"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            Ver Usuario
                                        </Link>
                                        <Link
                                            to={`/perfil/${emp.idUsuario}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            Ver Perfil
                                        </Link>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </div>
                    </Card>
                </Col>
            ))}
        </>
    );
};

CardsEmpleados.propTypes = {
    empleados: PropTypes.array
};

export default CardsEmpleados;